import type { AxiosRequestConfig } from "axios";

import type { IQuery } from "@citrine/client";
import ClientBase from "@citrine/client";

import type { Team } from "./team";

interface TeamQuery extends IQuery {
  page?: number;
  per_page?: number;
  as_admin?: boolean;
}

export class TeamClient extends ClientBase<Team, string, TeamQuery> {
  private static instance: TeamClient | undefined;

  // delete is not yet implemented in the backend
  delete: never;
  useDelete: never;

  protected constructor() {
    super({
      endpoint: "/api/v3/teams",
      getField: "team",
      findField: "teams",
      defaultQuery: {
        page: 1,
        // these objects are lightweight, so we can request more than 20 at a time
        per_page: 100,
        as_admin: undefined,
      },
    });
  }

  static getInstance() {
    return (this.instance ??= new this());
  }

  protected updateConfig(team: Team): AxiosRequestConfig {
    return {
      ...super.updateConfig(team),
      method: "PATCH",
    };
  }

  protected findConfig(query?: TeamQuery) {
    return {
      method: "POST",
      url: `${this.endpoint}/search`,
      data: query?.search
        ? {
            search_params: {
              name: {
                value: query.search,
                search_method: "SUBSTRING",
              },
            },
          }
        : {},
      params: this.normalizeQuery(query),
    };
  }
}
